module.exports = global["SegmentIO"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/index.js
// module id = 90
// module chunks = 0